<template>
  <div>
    <div v-if="carregando == true" class="carregando">
      <img width="130px" :src="iconeCarregando" />
      <br />
      <br />Carregando...
    </div>
    <div class="container text-center mb-3">
      <!--div class="alert-danger rounded p-2">
        <h3 class="title-alert">🖤 Atenção, Fiel!</h3>
        <p class="text-alert">
          <br />Fique atento as novidades: Estamos preparando novas caixas,
          produtos e experiências exclusivas. Voltamos no dia 23/04/25
        </p>
      </div-->
    </div>
    <div class="deskContent">
      <div class="filtro d-flex align-items-center container">
        <div
          class="d-flex flex-column flex-md-row align-items-md-center justify-content-md-between w-100"
        >
          <div>
            <div class="pt-2 d-md-flex align-items-center ">
              <div class="d-flex align-items-center mr-5 pb-2 pb-md-0">
                <h3 class="font-weight-bold mb-2">
                  ESCOLHA SUA CAIXA
                </h3>
              </div>
              <div
                v-if="possuiCategoriaSelecionada"
                class="d-flex pt-1 pb-4 pb-md-0"
              >
                <button class="all-category" @click="verTodas()">
                  VER TODAS AS CAIXAS<i class="fa fa-chevron-right pl-2"></i>
                </button>
              </div>
            </div>
          </div>
          <div
            class="d-flex justify-content-start justify-content-md-end deskContent"
          >
            <div
              @click="filtraTipo(item.idTipo, item.selecionado)"
              class="categoria-none-select p-2 border  d-flex mr-2"
              :class="item.selecionado ? 'categoria-yellow' : ''"
              v-for="item in categorias"
              :key="item.idTipo"
            >
              <span class="font-weight-bold">{{ item.nomeTipo }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="phoneContent">
      <h3
        class="titulo font-weight-bold mb-0"
        :class="fromHome ? 'ml-3' : 'ml-2'"
      >
        ESCOLHA SUA CAIXA
      </h3>
    </div>

    <div class="container">
      <div class="lista-de-caixas" v-if="caixasFiltred.length > 0">
        <div v-for="item in caixasFiltred" :key="item.idCaixa">
          <box :box="item"></box>
        </div>
      </div>
      <div class="row" v-else>
        <div v-if="textoFiltro" class="col my-3">
          <div></div>
          <Alert
            type="warning"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
            >Nenhum Box encontrada em: <br />
            <div v-if="categoriaSelecionada">
              <b>Categoria:</b> {{ categoriaSelecionada.nomeTipo }}
            </div>
            <div v-if="palavraChave">
              <b>Palavra Chave:</b> {{ palavraChave }}
            </div>
          </Alert>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import box from './box.vue';
import service from './../../../services';
export default {
  components: {
    box,
  },
  props: ['fromHome'],
  data() {
    return {
      carregando: false,
      decoded: {},
      filtro: {},
      caixas: [],
      caixasFiltred: [],
      categorias: [],
      categoriaSelecionada: null,
      palavraChave: null,
      textoFiltro: null,
      possuiCategoriaSelecionada: false,
      iconeCarregando: service.getEnvIconeCarregando(),
    };
  },
  methods: {
    redirecionaCaixa(caixa, caixaCompleta) {
      if (caixaCompleta) this.$router.push(`${caixa}`);
    },
    filtraTipo(tipo, selecionado) {
      if (selecionado) {
        this.verTodas();
        return;
      }
      this.possuiCategoriaSelecionada = true;
      this.categorias.forEach(element => {
        element.selecionado = false;
        if (element.idTipo == tipo) {
          element.selecionado = true;
          this.categoriaSelecionada = element;
          this.textoFiltro = 'Categoria - ' + element.nomeTipo;
        }
      });
      this.caixasFiltred = this.caixas.filter(x => x.idTipo == tipo);
      this.filtraPalavraChave();
    },
    buscarDados() {
      this.carregando = true;
      service.getAll('Caixa', {}, 'Listar/ativo/1?idEmpresa=null').then(res => {
        console.log(res.data);
        this.caixas = res.data;
        this.caixasFiltred = res.data;
        //this.$scrollTo("#Resultados");
        this.carregando = false;
      });
    },
    buscarTipos() {
      this.carregando = true;

      service
        .getAll('TipoCaixa', {}, 'Listar/ativo?idEmpresa=null')
        .then(res => {
          this.categorias = [];
          console.log(res.data);
          res.data.forEach(element => {
            element.selecionado = false;
            this.categorias.push(element);
          });
          this.categorias = res.data;
          //this.$scrollTo("#Resultados");
          this.carregando = false;
        });
    },
    verTodas() {
      this.possuiCategoriaSelecionada = false;
      this.caixasFiltred = this.caixas;
      this.categorias.forEach(tipo => {
        tipo.selecionado ? (tipo.selecionado = false) : '';
      });
    },
  },
  async mounted() {
    await this.buscarDados();
    await this.buscarTipos();
  },
};
</script>

<style>
h3 {
  color: #fff;
}

.all-category {
  border: none;
  background-color: #dddddd00;
  color: #fff;
}

.categoria-yellow {
  background-color: #e0a800;
  border-radius: 8px;
  border: none;
  color: #000 !important;
}

.categoria-none-select {
  border-radius: 8px;
  border: none;
  color: #fff;
}

.categoria-none-select:hover {
  background-color: #e0a800;
}

.text-alert {
  font-size: 18px;
}

.title-alert {
  color: #0d0d0d;
  font-size: 25px;
  font-weight: 700;
  margin: 0;
  padding: 0;
}
</style>
